/** Values persisted as KYB/settings placeholders — omit from invoice preview/PDF. */
const PLACEHOLDER_ADDRESS_TOKENS = new Set(["n/a", "na", "-", "—", "none", "null"]);

export function isPlaceholderAddressPart(value: unknown): boolean {
  const normalized = String(value ?? "").trim().toLowerCase();
  if (!normalized) return true;
  if (PLACEHOLDER_ADDRESS_TOKENS.has(normalized)) return true;

  const segments = normalized
    .split(/[,;\n]+/)
    .map((part) => part.trim())
    .filter(Boolean);
  return segments.length > 0 && segments.every((part) => PLACEHOLDER_ADDRESS_TOKENS.has(part));
}

export function filterPlaceholderAddressLines(lines?: string[] | null): string[] {
  return (lines ?? []).map((line) => String(line ?? "").trim()).filter((line) => line && !isPlaceholderAddressPart(line));
}

/** Invoice/receipt header line — null when UEN is empty so callers can hide it. */
export function formatBusinessUenLine(uen?: string | null): string | null {
  const trimmed = String(uen ?? "").trim();
  return trimmed ? `UEN ${trimmed}` : null;
}

/** Client billing / multiline address — one PDF/preview line per non-empty row. */
export function splitMultilineAddressLines(value?: string | null): string[] {
  return filterPlaceholderAddressLines(
    String(value ?? "")
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter(Boolean),
  );
}
